var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"facebook\"><path fill=\"#fff\" d=\"M16 8.049C16 3.603 12.419 0 8 0S0 3.603 0 8.049C0 12.067 2.925 15.396 6.75 16v-5.624H4.719V8.048h2.03V6.275c0-2.017 1.195-3.132 3.023-3.132.874 0 1.79.158 1.79.158v1.98h-1.009c-.994 0-1.303.621-1.303 1.258v1.51h2.219l-.355 2.326H9.25V16c3.825-.604 6.75-3.933 6.75-7.951\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol